<template>
  <div>
    <div class="container">
      <div class="columns">
        <div class="column">
          <taskBrowser :submissions="submissions" :projects="projects" type="journal"></taskBrowser>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import taskBrowser from "@/components/tasks/Browser.vue";
import { mapState } from "vuex";
import { CourseClient } from "../clients/CourseClient";

export default {
  name: "Tasks",

  components: {
    taskBrowser
  },

  data() {
    return {
      projects: []
    };
  },

  computed: {
    ...mapState({
      submissions(state) {
        return state.documentStore.documents.filter(
          document => document.project
        );
      }
    })
  },
  mounted() {
    this.$store.dispatch("GET_USER_DOCUMENTS");
    this.getProjects();
  },

  methods: {
    getProjects() {
      CourseClient.getProjects()
        .then(result => {
          this.projects = result.data.projects;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>


